<template>
  <v-layout
    row
    class="listing"
    my-3
    elevation-3
  >
    <v-img
      :src="imageUrl"
      max-height="200"
      max-width="300"
      class="mr-3"
    />
    <v-layout column>
      <v-layout row my-3>
        <h4 class="display-1">
          {{ tenant.name }}
        </h4>
        <v-spacer />
        <v-btn v-if="!noEdit" @click="$emit('edit', tenant.id)">
          Edit
        </v-btn>
        <v-btn v-if="!noEdit" color="error" @click="$emit('remove', tenant.id)">
          Delete
        </v-btn>
      </v-layout>
      <v-layout column wrap>
        <v-flex class="subheading">
          Date of Birth: {{ tenant.dateOfBirth | formatDate }}
        </v-flex>
        <v-flex class="subheading">
          Social Security Number: {{ tenant.ssnnumber }}
        </v-flex>
        <v-flex class="subheading">
          Driver License Number: {{ tenant.driverlicense }}
        </v-flex>
        <v-flex class="subheading">
          Email: {{ tenant.email }}
        </v-flex>
        <v-flex class="subheading">
          Phone Number: {{ tenant.phonenumber }}
        </v-flex>
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
import { storage } from 'firebase/app';
import 'firebase/storage';
import dayjs from 'dayjs';
import { toDollar } from '@/util';

export default {
  name: 'Tenant',
  filters: {
    toDollar,
    formatDate: date => date && dayjs(date).format('MMMM D, YYYY'),
  },
  props: {
    tenant: {
      required: true,
      type: Object,
    },
    noEdit: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    imageUrl: '',
  }),
  async created() {
    this.imageUrl = await storage()
      .ref(`tenants/${this.tenant.id}`)
      .getDownloadURL();
  },
};
</script>

<style>
.listing {
  max-height: 200px;
}
</style>
